import { ValueList } from "../ValueList"

import type { CVEIncident } from "@/domain/adr"

export const CveList = ({ record }: { record: CVEIncident }) => {
  const items = record.what.vulnerabilitiesMeta.CVEs.list

  return <ValueList limit={3} items={items} titleKey="general.cve" />
}
